// based on https://stimulus-components.netlify.app/docs/components/stimulus-checkbox-select-all/

// MIT License

// Copyright (c) 2020 Guillaume Briday, updated by Storm Consultancy (EU) Ltd

// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:

// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.

// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.

import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['checkboxAll', 'checkbox']

  initialize () {
    this.toggle = this.toggle.bind(this);
    this.refresh = this.refresh.bind(this);
  }

  connect () {
    this.refresh();
  }

  set(e) {
    e.preventDefault()
    this.checkboxTargets.forEach(checkbox => {
      const wasChecked = checkbox.checked
      checkbox.checked = true
      if (!wasChecked) {
        checkbox.dispatchEvent(new CustomEvent("change", {}))
      }
    })
  }

  unset(e) {
    e.preventDefault()
    this.checkboxTargets.forEach(checkbox => {
      const wasChecked = checkbox.checked
      checkbox.checked = false
      if (wasChecked) {
        checkbox.dispatchEvent(new CustomEvent("change", {}))
      }
    })
  }

  toggle (e) {
    e.preventDefault();

    this
      .element
      .querySelectorAll("[data-target='checkbox-select-all.checkbox']")
      .forEach(checkbox => {
        const wasChecked = checkbox.checked
        checkbox.checked = e.target.checked
        if (wasChecked ^ checkbox.checked) {
          checkbox.dispatchEvent(new CustomEvent("change", {}))
        }
      })
  }

  refresh () {
    if (this.hasCheckboxAllTarget) {
      const checkboxesCount = this.checkboxTargets.length;
      const checkboxesCheckedCount = this.checked.length;
      this.checkboxAllTarget.checked = checkboxesCheckedCount > 0;
      this.checkboxAllTarget.indeterminate = checkboxesCheckedCount > 0 && checkboxesCheckedCount < checkboxesCount;
    }
  }

  get checked () {
    return this.checkboxTargets.filter(checkbox => checkbox.checked);
  }

  get unchecked () {
    return this.checkboxTargets.filter(checkbox => !checkbox.checked);
  }
}
